import { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

const LiveLayer = styled.div<{ $covered: boolean }>`
  height: 100%;

  ${({ $covered }) =>
    $covered
      ? css`
          position: relative;
          z-index: 0;
          isolation: isolate;
          pointer-events: none;
        `
      : ''}
`;

const INERT_PROPS = { inert: '', 'aria-hidden': true } as Record<
  string,
  unknown
>;

export interface AiFocusSlotProps {
  placeholder: ReactNode | null;
  children?: ReactNode;
}

export const AiFocusSlot: FC<AiFocusSlotProps> = ({
  placeholder,
  children,
}) => {
  const covered = Boolean(placeholder);
  return (
    <>
      <LiveLayer
        $covered={covered}
        data-qa-id="ai-focus-live"
        {...(covered ? INERT_PROPS : {})}
      >
        {children}
      </LiveLayer>
      {placeholder}
    </>
  );
};
